import { render } from "./DrivenCharacteristics.vue?vue&type=template&id=4df50cb0"
import script from "./DrivenCharacteristics.vue?vue&type=script&lang=js"
export * from "./DrivenCharacteristics.vue?vue&type=script&lang=js"
script.render = render

export default script